// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

firebase: {
  apiKey: "AIzaSyASzF6QBcQc70LFjQAlEgfB7prB8OmN6QY",
  authDomain: "devproject-c6b36.firebaseapp.com",
  databaseURL: "https://devproject-c6b36.firebaseio.com",
  projectId: "devproject-c6b36",
  storageBucket: "devproject-c6b36.appspot.com",
  messagingSenderId: "340214749497",
  appId: "1:340214749497:web:2980d0065f35ee99d130e8",
  measurementId: "G-7RR8SSBXCG"


},


};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
